<template>
<div :class="{root: true}" >
    <Alert v-if="show_alert" @closed="show_alert=false" :alert="alert"/>
    <NavBar />
    <div class="d-flex justify-content-center">
        <rating v-if="show_rating" :data="rating" :assistant="assistant" @closeMe="deactivateRating"/>
    </div>
    <div class="content">
        <transition name="router-animation">
            <router-view />
        </transition>
    </div>
    <Footer />
    <LoginForm 
        v-if="show_login" 
        @closed="closeLogin" 
        @signUp='swopSign' 
        :eventKeyId="$store.getters.eventKeyId"
        :use_license="true"
        :selector="true"
    />
    <RegistrationForm 
      v-if="show_sign" 
      @closed="closeSign" 
      :eventKeyId="$store.getters.eventKeyId" 
      :preliminary_data= "init_value"
    />
    <DiplomaForm 
        v-if="show_diploma" 
        @closed="closeDiploma" 
        :assistant="{
            'name': assistant.name, 
            'email': assistant.email, 
            'id':assistant.id, 
            'key_id':assistant.key_id
        }"
        :floatingRules="floatingRules"
    />
    <ExamForm 
        v-if="show_exam" 
        @closed="closeExam" 
        :assistant="{
            'name': assistant.name, 
            'email': assistant.email, 
            'id':assistant.id, 
            'key_id':assistant.key_id
        }"
    />
    <SurveyForm 
        v-if="show_survey" 
        @closed="closeSurvey" 
        :assistant_key_id="assistant.key_id" 
        :assistant_id="assistant.id" 
        :survey_id="event.survey"
        :is_mandatory="true"
    />
    <ChatBox
        :key="chat_key"
        v-if="$store.getters.isLoggedIn && !$store.getters.watching_broadcast && ($store.getters.isModuleActive('Chat') || $route.name == 'OnSite')" 
        :assistant="assistant" 
        icon="question-circle-fill"
        icon_variant="danger"
        :icon_font_scale="3"
        :room="$route.name == 'OnSite'?room?room.room:'Presencial':'Virtual'"
    />
    <poll v-if="show_poll" :data="poll" :assistant="assistant" @closed="show_poll = false"/>
    <WordCloud v-if="show_cloud" :data_cloud="word_cloud" :assistant="assistant" @closed="closeWordCloud"/>
</div>
</template>

<script>
import Vue from 'vue'
import NavBar from '@/components/NavBar/NavBar.vue'
import Footer from '@/components/Footer/Footer.vue'
import LoginForm from '@/components/LoginForm/LoginForm.vue'
import DiplomaForm from '@/components/DiplomaForm/DiplomaForm.vue'
import ExamForm from '@/components/ExamForm/ExamForm.vue'
import SurveyForm from '@/components/SurveyForm/SurveyForm.vue'
import Poll from '@/components/Poll/Poll.vue'
import RegistrationForm from '@/components/RegistrationForm/RegistrationForm.vue'
import Rating from '@/components/Rating/Rating.vue'
import OnInitModal from '@/components/OnInitModal/OnInitModal.vue'
import Alert from '@/components/Alert/Alert.vue'
import ChatBox from '@/components/Chat/ChatBox.vue'
import WordCloud from '@/components/WordCloud/WordCloud.vue'

export default Vue.extend({
    name: "Layout",
    components: { 
        NavBar
        , Footer,
        LoginForm,
        DiplomaForm,
        ExamForm,
        SurveyForm, 
        Poll, 
        RegistrationForm,
        Rating,
        OnInitModal,
        Alert,
        ChatBox,
        WordCloud
    },
    data() {
        return {
            show_alert: false,
            alert: null,
            show_diploma: false,
            show_login: false,
            show_exam: false,
            show_survey: false,
            show_cloud: false,
            chat_its_open: false,
            show_poll: false,
            poll: null,
            show_sign: false,
            show_registration: false,
            show_rating: false,
            rating: null,
            chat_key: 0,
            floatingRules: [],
            assistant_id: null,
            word_cloud: null
        }
    },
    methods: {
        fastAccess() {
            let loader = this.$loading.show()
            this.errors = []
            this.$store.dispatch(
                'post', 
                {
                    url: '/assistants/fast_access', 
                    data: {
                        key_id: this.assistant_id,
                        browser_info: this.$browserDetect.meta.ua,
                        site: this.$store.getters.site_location
                    }, 
                    headers:{}
                }
            )
            .then((resp) => {
                loader.hide()
                let active_word_clouds = resp.data.active_word_clouds
                active_word_clouds.forEach(element => {
                    if(element.json_options) element.json_options = JSON.parse(element.json_options)
                });

                this.$store.commit(
                    'auth_success', 
                    {
                    'token': resp.data.key_id,
                    'assistant': {
                        'name': resp.data.full_name,
                        'email': resp.data.email,
                        'nickname': resp.data.nickname,
                        'id': resp.data.id,
                        'key_id': resp.data.key_id,
                        'remaining_attempts': resp.data.remaining_attempts,
                        'exam_approved': resp.data.exam_approved,
                        'answered_survey': resp.data.answered_survey,
                        'session_id': resp.data.session_id,
                        'join_url': resp.data.join_url,
                        //'active_word_clouds':active_word_clouds
                    },
                    'email': resp.data.email,
                    'remember_me': true
                    }
                )
                if(resp.data.join_url) this.$store.commit('set_url_to', resp.data.join_url)
                else this.$store.commit('set_url_to', this.event.url_to)
                this.$nextTick(() => {
                    this.$store.commit('set_data_poll', resp.data.poll_data)
                    this.$store.commit('set_data_rating', resp.data.pending_ratings)
                    this.$store.commit('set_data_word_cloud', active_word_clouds)
                    /* resp.data.poll_data.forEach(element => {
                        //this.$eventHub.$emit('startPoll', {poll: element, survey: element.survey})
                        //this.$store.commit('set_data_poll', {poll: element, survey: element.survey})
                    }); */
                    /* resp.data.pending_ratings.forEach(element => {
                        //this.$eventHub.$emit('activateRating', {rating: element})
                        this.$store.commit('set_data_rating', {rating: element})
                    }); */
                })
                
            })
            .catch(err => {
                loader.hide()
                this.errors = err.errors
            })
        },
        scrollToTop() {
            window.scrollTo(0,0);
        },
        showLogin() {
            this.show_login = true
        },
        showAlert(alert) {
            this.alert = alert
            this.show_alert = true
        },
        closeLogin(msg) {
            this.scrollToTop()
            this.show_login = false
            this.show_sign = false
            if(msg) this.showMsgBox(msg)
        },
        closeWordCloud(msg) {
            this.scrollToTop()
            this.show_cloud = false
            if(msg) this.showMsgBox(msg)
        },
        showMsgBox(msg) {
            if(msg && msg.title){
                this.$bvModal.msgBoxOk(msg.text, {
                    title: msg.title,
                    titleClass: 'h2',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true,
                    noEnforceFocus: true
                })
                .then(value => { 
                    this.scrollToTop()
                })
                .catch(err => {
                
                })
            }
        },
        swopSign(param) {
            this.show_login= false
            this.email = null,
            this.init_value = Object({})
            if(typeof(param) != "string") {
                this.init_value = param
            } else {
                this.email = param
                this.init_value.email = param
            }
            if(!this.show_sign) {
                if(this.event.closed === 1 ) {
                this.showMsgBox(
                    {
                    'text': 'El registro al evento está cerrado, regrese más tarde.',
                    'title': 'Aviso....'
                    }
                )
                } else this.show_sign = !this.show_sign
            } else {
                this.show_sign = !this.show_sign
            }
            
        },
        showDiploma(floatingRules) {
            if(this.event.survey_enabled && !this.answeredSurvey) {
                this.$bvModal.msgBoxOk('Antes de descargar su constancia, por favor conteste una breve encuesta. Al terminar vuelva a dar click en el botón de Obtener Constancia.', {
                    title: 'Aviso',
                    titleClass: 'h2',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                })
                .then(value => { 
                    this.show_survey = true
                })
            } else {
                this.floatingRules = floatingRules
                this.show_diploma = true
            }
        },
        closeDiploma(msg) {
            this.scrollToTop()
            this.show_diploma = false
            if(msg) this.showMsgBox(msg)
        },
        showExam() {
            if(this.event.enable_exam && !this.answeredSurvey) {
                this.$bvModal.msgBoxOk('Antes de responder su examen, por favor conteste una breve encuesta. Al terminar vuelva a dar click en el botón de Responder Examen.', {
                    title: 'Aviso',
                    titleClass: 'h2',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                })
                .then(value => { 
                    this.show_survey = true
                })
            } else {
                this.show_exam = true
            }
        },
        closeExam(msg) {
            this.scrollToTop()
            this.show_exam = false
            if(msg) this.showMsgBox(msg)
        },
        showSurvey() {
            if(!this.answeredSurvey) this.show_survey = true
        },
        closeSurvey(msg) {
            this.scrollToTop()
            this.show_survey = false
            this.$store.commit('set_already_answered', true)
        },
        startPoll(data) {
            this.poll = data
            this.show_poll = true
        },
        endPoll(data) {
            if(!this.$store.getters.isModuleActive('PrecentialRooms')) {
                this.poll = null
                this.show_poll = false
            } else if (this.poll && (this.poll.id == data.id)) {
                this.poll = null
                this.show_poll = false
            }
            
        },
        closeSign(msg) {
            this.scrollToTop()
            this.show_login = false
            this.show_sign = false
            if(msg.title) this.showMsgBox(msg)
        },
        showRegistration() {
            this.show_registration = !this.show_registration
        },
        activateRating(data) {
            this.rating = data
            this.show_rating = true
        },
        deactivateRating(data) {
            if(!data) this.show_rating = false
            else if(!this.$store.getters.isModuleActive('PrecentialRooms')) {
                this.show_rating = false
            } else if (this.rating && (this.rating.key_id == data.key_id)) {
                this.show_rating = false
            }
        },
        activateWord(data) {
            this.word_cloud = data
            this.show_cloud = true
        },
        deactivateWord(data) {
            this.show_cloud = false
        },
        joinZoom(room_name) {
            let temp= this.$store.getters.join_links.find((item) => item.room_name === room_name )

            if( temp ) { this.redirectToZoom(temp.url)
            } else {
                let loader = this.$loading.show()
                this.$store.dispatch(
                    'post', 
                    {
                        url: '/assistants/public_my_zoom_url', 
                        data: {
                            key_id: this.assistant.key_id,
                            short_name: room_name
                        }, 
                        headers:{}
                    }
                ).then((resp) => {
                    if(resp.data.join_url) {
                        let url = this.$store.getters.join_links
                        url.push({room_name: room_name, url: resp.data.join_url})
                        this.$store.commit('set_join_links', url)
                    }

                    this.$nextTick(() => {
                        this.redirectToZoom(resp.data.join_url)
                    })
                }).catch(err => {
                    console.error(err)
                }).finally(()=>{ 
                    loader.hide()
                });
            }
        },
        redirectToZoom(url_to) {
            // Create link in memory
            var a = window.document.createElement("a");
            a.target = '_blank';
            a.href = url_to
        
            // Dispatch fake click
            var e = window.document.createEvent("MouseEvents");
            e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
        }
    },
    computed: {
        answeredSurvey : function() {
            return this.$store.getters.already_answered
        },
        assistant : function() { return this.$store.getters.assistant },
        event : function() { return this.$store.getters.event },
        room : function() { return this.$store.getters.room },
        onInitModalModule : function() { return this.$store.getters.getModule('OnInitModal') },
        onInitData: function() {
            if(this.onInitModalModule) return this.onInitModalModule.content
            return null
        },
    },
    watch: {
        room(newValue, oldValue) {
            if(newValue.room) this.chat_key ++
        }
    },
    beforeMount () {
        if(this.$route.name == 'Home' || this.$route.name == 'OnSite') {
            try {
                this.assistant_id = localStorage.getItem("u")
            } catch (error) {
                this.assistant_id = null
            }
            if(this.assistant_id) this.fastAccess()
        }
        /* console.log(Object.entries(this.$route.query)) */
    },
    created () {
        this.$eventHub.$on('showAlert', this.showAlert);
        this.$eventHub.$on('showLogin', this.showLogin);
        this.$eventHub.$on('showDiploma', this.showDiploma);
        this.$eventHub.$on('showExam', this.showExam);
        this.$eventHub.$on('showSurvey', this.showSurvey);
        this.$eventHub.$on('startPoll', this.startPoll);
        this.$eventHub.$on('endPoll', this.endPoll);
        this.$eventHub.$on('showRegistration', this.showRegistration);
        this.$eventHub.$on('activateRating', this.activateRating);
        this.$eventHub.$on('deactivateRating', this.deactivateRating);
        this.$eventHub.$on('showMsgBox', this.showMsgBox);
        this.$eventHub.$on('activateWord', this.activateWord);
        this.$eventHub.$on('deactivateWord', this.deactivateWord);
        this.$eventHub.$on('joinZoom', this.joinZoom);
        if(this.$route.name === 'OnSite') {
            this.$store.commit('set_site_location', 'WebApp')
        } else {
            this.$store.commit('set_site_location', 'Virtual')
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/app';

.content {
    margin-top: $navbar-height*.8 !important;
}
</style>